<template>
    <div class="home-page">
        <div>
            <div @click="back" class="back">

                <img src="@/assets/imgs/back_w.png" alt="">
                <span>返回系统</span>
            </div>

        </div>
        <div class="title"><img src="@/assets/imgs/icontext.png" alt=""></div>
        <div class="list">
            <div class="all">
                <div v-for="(item,index) in list" :key="index" class="sings" @click="nextPage(item)">
                    <div class="bg"></div>
                    <div class="sing"><p>{{item.name}}</p>
                        <h1>{{item.title}}</h1>
                        <div class="rich">{{item.desc}}</div>
                        <div class="img"><img src="@/assets/imgs/arrow_w.png" alt=""></div>

                    </div>
                </div>
            </div>


        </div>
        <div>
            <img src="@/assets/imgs/home_bottom.png" alt="" class="bottom">
            <img src="@/assets/imgs/bar.png" alt="" class="bar-img" />

        </div>
    </div>
</template>

<script>
    import {index,save_visit} from '@/api/module/api'
    export default {
        name: "home",
        data(){
            return {
                list:[]
            }
        },
        created() {
            this.savePage();
            this.getIndex();
        },
        methods: {
            async savePage(){
                const {data}=await save_visit({
                    type:2
                })
            },
            async getIndex(){
              const {data}=await index();
              this.list=data;

            },
            back() {
                this.$router.push('/')
            },
            nextPage(item) {
                this.$router.push({path:'/time',query:{visit_id:item.id}})
            }
        }
    }
</script>

<style scoped>
    .home-page {
        width:100vw;
        height: 100vh;
        background: url(../assets/imgs/home_bg.png);
        background-size: 100% 100%;
    }

    .home-page .title {

        display: flex;
        justify-content: center;
    }

    .home-page .title img {
        width: 28.4vw;
    }

    .home-page .bottom {
        position: fixed;
        bottom: 0;
        width: 100%;
      bottom:-3%;
    }
    .home-page .bar-img {
        position: fixed;
        bottom: 0;
        right: 0;
        width: 8%;
    }
    .home-page .back {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding: 2.6vw 2.6vw 1vw 0;
    }

    .home-page .back img {
        width: 2.1vw;
        margin-right: 10px;
        /*margin-top: 6px;*/
    }

    .home-page .back span {
        color: white;
        font-size: 1.8vw;

    }

    .list {
        position: fixed;
        width: 100%;
        bottom: 6%;
    }

    .list .all {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        padding: 0 5.2vw 0 6.7vw;
        grid-gap: 6.7vw;
    }

    /*.sings{margin-right: 130px;}*/
    .list .sing {
        /*width: 14.2vw;*/
        height: 55vh;
        background: white;
        padding: 1.4vw;
        position: relative;
        z-index: 99;
    }

    .list .bg {
        content: '';
        display: inline-block;
        background: #DEB573;
        width: 14.2vw;
        height: 35vh;
        position: absolute;
        left: -30px;
        top: -30px;
        z-index: -1;
    }

    .all .sings {
        position: relative;
    }

    .list .sing p {
        color: #C78B33;
        font-size: 1.6vw;
        font-weight: bold;
    }

    .list .sing h1 {
        color: #DE291E;
        font-weight:700;
        font-size: 1.6vw;
    }

    .list .rich {
        font-size: 0.8vw;
        color: #333;
        line-height: 1.2vw;
        margin-top: 1vw;
        font-weight: bold;
        height: 14vh;
        letter-spacing: 2px;
    }

    .list .img {
        display: flex;
        justify-content: flex-end;
    }

    .list .img img {
        cursor: pointer;
        background: #DB3127;
        width: 3.5vw;
        height: 2vw;
        padding: 10px 1vw;
        border-radius: 10vw;
        font-size: initial;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 999;

    }
</style>
